module.exports = __webpack_public_path__ + "static/sport/h5-form-bg.79d5a0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/football/h5/h5-form-bg.png
// module id = ioS0
// module chunks = 0